import { render, staticRenderFns } from "./MultipleUploadImg.vue?vue&type=template&id=371216b4&scoped=true&"
import script from "./MultipleUploadImg.vue?vue&type=script&lang=js&"
export * from "./MultipleUploadImg.vue?vue&type=script&lang=js&"
import style0 from "./MultipleUploadImg.vue?vue&type=style&index=0&id=371216b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371216b4",
  null
  
)

export default component.exports